import React, { useEffect, useState } from 'react';

import { Assignment, CheckOutlined } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { makeStyles } from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Mesa', accessor: 'base_bureau_description' },
  { Header: 'Estado', accessor: 'state', width: 150, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function SaleForces(props) {
  const classes = useStyles();
  const { setSelectSF, setOpenModalSF } = props;
  const [saleForces, setSaleForces] = useState([]);
  async function listSaleForces() {
    let response = await wsGetAll('base/sale-force');
    if (response.success) setSaleForces(response.data);
  }

  useEffect(() => {
    listSaleForces();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Listado de Fuerzas de Venta</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          excelName="Ferzas-de-venta"
          defaultWidth={1200}
          columns={columns}
          data={saleForces.map((saleForce, i) => {
            return {
              num: (
                <div className="actions-right">
                  {i + 1}
                  <Button
                    justIcon
                    round
                    size="sm"
                    color={props.themeContext.buttonColorSuccess}
                    onClick={() => {
                      setSelectSF(saleForce);
                      setOpenModalSF(false);
                    }}
                    style={{ marginLeft: '8px' }}
                  >
                    <CheckOutlined />
                  </Button>
                </div>
              ),
              base_zone_description: `${saleForce.base_zone_code} - ${saleForce.base_zone_description}`,
              WhsName: `${saleForce.WhsCode} - ${saleForce.WhsName}`,
              base_bureau_description: `${saleForce.base_bureau_code} - ${saleForce.base_bureau_description}`,
              state: saleForce.state === 'A' ? 'Activo' : 'Inactivo',
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
